import { INTEGRATION_STATUS_ACTIVE } from '../analytic/constants';

export const isKlaviyoActive = () => {
  const env = window.boostWidgetIntegration?.env;
  const integration = window.boostWidgetIntegration?.app?.[env]?.integration;
  const klaviyoStatus = integration?.emailSMS?.klaviyo;
  if (klaviyoStatus === INTEGRATION_STATUS_ACTIVE) {
    return true;
  }
  return false;
};
